<template>
    
    <div class="main">
        <c-panel>
            <form-alergia :paramId="$route.params.id" v-on:onSubmitAlergia="onSubmitAlergia"></form-alergia>
        </c-panel>
    </div>
    
</template>
<script>

import formAlergia from "./form"

export default {
    methods:{

        onSubmitAlergia(){

            this.$router.push('/admin/dados-medicos/0');
        }
    },
    components:{ formAlergia }
}
</script>
